import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Users } from 'lucide-react';
import { Button } from './ui/Button';
import { Section } from './ui/Section';
import { Link } from 'react-router-dom';
export function Hero() {
  return <div className="relative overflow-hidden bg-slate-50 pt-16 pb-16 md:pt-32 md:pb-24" data-id="element-158">
      {/* Background Pattern */}
      <div className="absolute inset-0 z-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(#1a061f 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-159"></div>

      <Section className="relative z-10 !py-0" data-id="element-160">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-161">
          {/* Left: Text Content */}
          <div className="text-center lg:text-left" data-id="element-162">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-primary/20 text-brand-primary text-sm font-medium mb-8" data-id="element-163">
              <ShieldCheck className="w-4 h-4" data-id="element-164" />
              <span data-id="element-165">Trusted by 5,000+ Students & Parents</span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-5xl md:text-7xl font-bold tracking-tight text-brand-dark mb-6" data-id="element-166">
              Student Housing,{' '}
              <span className="text-brand-primary" data-id="element-167">Verified.</span>
              <br data-id="element-168" />
              Roommates, <span className="text-brand-primary" data-id="element-169">Matched.</span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-xl text-slate-600 mb-10 max-w-2xl leading-relaxed" data-id="element-170">
              The only platform that combines physical hostel verification with
              AI-driven roommate pairing to ensure a safe, fraud-free campus
              experience.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center lg:justify-start" data-id="element-171">
              <a href="https://tally.so/r/eq2RBO" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-172">
                <Button size="lg" className="w-full group" data-id="element-173">
                  Join Our Waitlist
                  <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-174" />
                </Button>
              </a>
            </motion.div>

            {/* Trust Indicators */}
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 0.5
          }} className="mt-16 pt-8 border-t border-slate-200" data-id="element-175">
              <p className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-6" data-id="element-176">
                Ensuring Safety Across Top Campuses
              </p>
              <div className="flex flex-wrap justify-center lg:justify-start gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-177">
                <span className="text-xl font-bold text-brand-dark" data-id="element-178">FUTA</span>
                <span className="text-xl font-bold text-brand-dark" data-id="element-179">
                  UNILAG
                </span>
                <span className="text-xl font-bold text-brand-dark" data-id="element-180">
                  COVENANT
                </span>
                <span className="text-xl font-bold text-brand-dark" data-id="element-181">
                  BABCOCK
                </span>
                <span className="text-xl font-bold text-brand-dark" data-id="element-182">UI</span>
              </div>
            </motion.div>
          </div>

          {/* Right: Hostel Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="relative hidden lg:block" data-id="element-183">
            <div className="relative" data-id="element-184">
              <img src="https://cdn.magicpatterns.com/uploads/wDxVU5ewHBAbGV4M9CD8C1/Copy_of_Billvast_Shirt_Mock-up_.png" alt="Verified Student Hostel" className="w-full h-auto max-w-md mx-auto drop-shadow-2xl" data-id="element-185" />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-4 shadow-xl" data-id="element-186">
                <div className="flex items-center gap-2 mb-1" data-id="element-187">
                  <ShieldCheck className="w-5 h-5 text-emerald-600" data-id="element-188" />
                  <span className="font-bold text-brand-dark" data-id="element-189">Verified</span>
                </div>
                <div className="text-sm text-slate-500" data-id="element-190">850+ Properties</div>
              </div>
            </div>
          </motion.div>
        </div>
      </Section>
    </div>;
}